import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FailedLoginModalComponent } from './components/failed-login-modal/failed-login-modal.component';
import { ADPComponentsModule } from 'digital-core';
import { CustomOktaCallbackComponent } from './components/okta-callback/oktaCallback.component';

@NgModule({
  declarations: [
    FailedLoginModalComponent,
    LoginComponent,
    LogoutComponent,
    CustomOktaCallbackComponent,


  ],
  imports: [
    ADPComponentsModule,
    CommonModule,
    SharedModule
  ],
  exports:[

    ADPComponentsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class AuthModule { }
